import {useLocation} from 'react-router-dom'

export const useQueryParams = () => {
  const {search} = useLocation()
  return new URLSearchParams(search)
}
